import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { SettingsSection } from "components/Settings/SettingsSection";

import { styled } from "@mui/material/styles";
import { useContext } from "react";
import { useFetchPostV2 } from "hooks/fetch/useFetchPostV2";
import { SnackbarQueueContext } from "contexts/SnackbarQueueContext";
import { useLoadCounter } from "hooks/useLoadCounter";

const PFButton = styled(Button)`
  display: inline-block;
  margin: ${({ theme }) => `${theme.spacing(2)} 0px 0px ${theme.spacing(1)}`};
`;

const ButtonWrapper = styled("div")`
  display: flex;
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing(1)};
`;

export const PowerFactorsSettingsSection = () => {
  const { addSnackbarToQueue } = useContext(SnackbarQueueContext);

  const {
    loading: getLoading,
    error: getError,
    response,
    refetch: refetchPowerFactors
  } = useFetchGetV2("settings/powerfactors_sync_status");

  const {
    loading: postLoading,
    error: postError,
    postCallback: powerfactorsPost
  } = useFetchPostV2("settings/powerfactors_sync_status");

  const loading = getLoading || postLoading;
  const error = getError || postError;
  const tableLoadCount = useLoadCounter(loading);

  const onSubmit = () => {
    powerfactorsPost({}).then(
      _success => {
        refetchPowerFactors().catch(() => {
          addSnackbarToQueue({
            message: "Failed to refresh PowerFactors failed sync information.",
            severity: "error"
          });
        });
        addSnackbarToQueue({
          message: "PowerFactors failed sync status reset.",
          severity: "success"
        });
      },
      err => {
        addSnackbarToQueue({
          message: "PowerBI Configuration failed to save.",
          severity: "error"
        });
      }
    );
  };

  if (loading) {
    return <>Loading...</>;
  } else if (error) {
    return <>Failed to load Powerfactors data</>;
  } else {
    return (
      <>
        <SettingsSection title="PowerFactors">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell data-col={1}>Name</TableCell>
                  <TableCell data-col={2}>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                data-qa_loading={loading}
                data-qa_load_count={tableLoadCount}
              >
                <TableRow>
                  <TableCell data-col={1}>Failed Syncs Count</TableCell>
                  <TableCell data-col={2}>{response?.count}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <ButtonWrapper>
            <PFButton
              type="submit"
              color="primary"
              variant="contained"
              onClick={onSubmit}
            >
              Reset PF Sync Status
            </PFButton>
          </ButtonWrapper>
        </SettingsSection>
      </>
    );
  }
};
